<template>
  <div class="top-header-area"
       id="sticker">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-sm-12 text-center">
          <div class="main-menu-wrap">
            <!-- logo -->
            <div class="site-logo"><a href="/"><img width="35"
                                                    src="/images/logo.png"
                                                    alt="">
              Blade<span style="color: #FFE018;">X</span>
            </a>
            </div><!-- logo -->
            <!-- menu start -->
            <nav class="main-menu">
              <ul>
                <li v-for="(item,index) in nav" :key="index" class="current-list-item">
                  <a :href="item.href"
                     v-if="item.href">
                    <span>{{item.title}}</span>
                  </a>
                  <router-link :to="item.path"
                               v-else>
                    <span>{{item.title}}</span>
                  </router-link>
                  <ul v-if="item.children" class="sub-menu">
                    <li v-for="(i, idx) in item.children" :key="idx">
                      <a :href="i.href">
                        {{i.title}}
                      </a>
                    </li>
                  </ul>
                </li>
                <div class="header-login">
                  <div v-if="!validatenull(user)">
                    <span style="float: left;cursor: pointer;width:110px" @click="handleCenter">个人中心</span>
                    <span style="float: left;margin-left: 5px;cursor: pointer;" @click="handleLogout">退出</span>
                  </div>
                  <div v-else>
                    <span
                      @click="handleOpen"
                      style="cursor: pointer;">登录</span>
                  </div>
                </div>
              </ul>
            </nav>

          </div>
        </div>
      </div>
    </div>
    <login ref="login"></login>
  </div>
</template>

<script>
  import nav from "@/nav.config.js";
  import {mapState} from 'vuex'
  import marketlist from "@/const/marketlist";

  export default {
    data() {
      return {
        nav
      };
    },
    computed: {
      ...mapState(['user']),
    },
    methods: {
      handleOpen() {
        this.$refs.login.handleOpen();
      },
      handleLogout() {
        this.$store.commit('logOut');
      },
      handleCenter() {
        if (this.validateMarketUser()) {
          this.$router.push('/user/product');
          return;
        }
        this.$router.push('/user/auth');
      },
      validateMarketUser() {
        if (this.validatenull(this.user)) {
          return false;
        }
        if (this.user === 'bladex') {
          return true;
        }
        const org = marketlist.filter(item => item.org === this.user)
        return !this.validatenull(org);
      }
    },
  };
</script>

<style lang="scss">
  .top-header-area {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #051922;
    padding: 15px 0;
    width: 100%;
  }

  .site-logo {
    a {
      color: #fff;
      font-size: 26px;
      font-weight: bold;
    }
  }

  .header-login {
    padding-top: 8px;
    float: right;

    span {
      display: block;
      padding: 3px 0;
      width: 80px;
      color: #ffe018;
      border: 1px solid #ffe018;
      text-align: center;
      border-radius: 3px;
    }
  }
</style>
